import { useState } from 'react';

const ITEMS = [
  { id: 1, product: 'Losartan 50 mg', supplier: 'Pharmasupply GmbH', missing: 'MA number · Registration date', priority: 'High', checked: true },
  { id: 2, product: 'Atorvastatin 40 mg', supplier: 'Sandoz NL', missing: 'Pack size · Container type', priority: 'Medium', checked: false },
  { id: 3, product: 'Amikacin 500 mg/2mL', supplier: 'MedDist BV', missing: 'EU-CTD number · NL availability date', priority: 'High', checked: true },
];

export default function DataCompletionModal({ show, onClose }) {
  const [items, setItems] = useState(ITEMS);

  if (!show) return null;

  const toggle = (id) => {
    setItems(prev => prev.map(i => i.id === id ? { ...i, checked: !i.checked } : i));
  };

  const checked = items.filter(i => i.checked);
  const supplierCount = new Set(checked.map(i => i.supplier)).size;

  return (
    <div className="modal-backdrop-fo" onClick={onClose}>
      <div className="modal-fo" onClick={e => e.stopPropagation()}>
        <button className="mcl" onClick={onClose}>✕</button>
        <div className="m-title">Request Data Completion</div>
        <div className="m-sub">Nova drafts personalised emails per supplier for missing fields. Patent status never requested.</div>

        <div className="d-flex flex-column gap-2 mb-3">
          {items.map(item => (
            <label key={item.id} className="d-flex align-items-center gap-3 p-3 rounded-2" style={{ background: 'var(--surf)', cursor: 'pointer' }}>
              <input type="checkbox" checked={item.checked} onChange={() => toggle(item.id)} />
              <div className="flex-grow-1">
                <strong>{item.product}</strong> — {item.supplier}
                <div style={{ fontSize: 11, color: 'var(--t3)' }}>Missing: {item.missing}</div>
              </div>
              <span className={`pill ${item.priority === 'High' ? 'p-r' : 'p-a'}`}>{item.priority}</span>
            </label>
          ))}
        </div>

        <div className="p-3 rounded-2 mb-3" style={{ background: 'var(--teal3)', fontSize: 12, color: 'var(--teal)' }}>
          ✦ Nova will draft tailored emails per supplier referencing their product list version and specific missing fields.
        </div>

        <div className="d-flex justify-content-end gap-2 pt-3 border-top">
          <button className="btn btn-s" onClick={onClose}>Cancel</button>
          <button className="btn btn-p" onClick={onClose}>Send via Nova ({supplierCount} supplier{supplierCount !== 1 ? 's' : ''})</button>
        </div>
      </div>
    </div>
  );
}
